import { DeleteOutline as DeleteOutlineIcon, Edit as EditIcon } from '@mui/icons-material';
import { MenuItem } from '@mui/material';
import { AuthContext } from 'providers/authProvider';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { hasPermission } from 'services/auth';

import { ConfirmModal, MoreMenu, NOTIFICATION_TYPE, Notification } from 'components';
import { useDeleteTransporter } from 'features/carriers/hooks/useDeleteCarrier';

const CarrierActionButton = ({ carrier }) => {
  const { user } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const { mutate: deleteCarrier, isLoading } = useDeleteTransporter({
    onSuccess: () => {
      setAnchorEl(null);
      Notification(NOTIFICATION_TYPE.SUCCESS, 'Carrier is removed successfully.');
    },
    onError: (err) => {
      Notification(NOTIFICATION_TYPE.DANGER, err.message);
    },
  });

  return (
    <>
      <MoreMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl}>
        <MenuItem
          onClick={() => setShowConfirm(true)}
          disabled={!hasPermission(user, { resource: 'carrier', action: 'delete' }) || isLoading}
          data-testid="delete-carrier-btn"
        >
          <DeleteOutlineIcon sx={{ mr: '1rem' }} />
          Remove
        </MenuItem>
        <MenuItem disabled={!hasPermission(user, { resource: 'carrier', action: 'update' })}>
          <Link to={`edit/${carrier.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <EditIcon sx={{ mr: '1rem' }} />
            Edit
          </Link>
        </MenuItem>
      </MoreMenu>

      <ConfirmModal
        show={showConfirm}
        handleClose={() => setShowConfirm(false)}
        title="Remove Carrier"
        content="Are you sure you want to remove this carrier?"
        onConfirm={() => deleteCarrier(carrier.id)}
      />
    </>
  );
};

export default CarrierActionButton;
